import { browser } from '@atlaskit/linking-common/user-agent';
var KeyZCode = 90;
var KeyYCode = 89;
export var isUndoEvent = function isUndoEvent(e) {
  var _browser = browser(),
    mac = _browser.mac;
  return e.keyCode === KeyZCode && (
  // cmd + z for mac
  mac && e.metaKey && !e.shiftKey ||
  // ctrl + z for non-mac
  !mac && e.ctrlKey);
};
export var isRedoEvent = function isRedoEvent(e) {
  var _browser2 = browser(),
    mac = _browser2.mac;
  return (
    // ctrl + y for non-mac
    !mac && e.ctrlKey && e.keyCode === KeyYCode || mac && e.metaKey && e.shiftKey && e.keyCode === KeyZCode || e.ctrlKey && e.shiftKey && e.keyCode === KeyZCode
  );
};